<template>
    <div id="talk-list">
        <van-pull-refresh v-model="loadingPullRefresh" @refresh="onRefresh">
            <van-list
                    v-model="loading"
                    :finished="finished || isError"
                    @load="onLoad"
            >
                <div class="talk" v-for="(item, key) in list" :key="item.id" :title="item.id" @click="commentSwitch(false)">
                    <div class="head">
                        <!-- <img class="avatar" v-lazy="item.avatar + '?imageView2/1/w/84/h/84'"
                             @click="$router.push(`/user/${item.userId}`)" /> -->
                             <!-- 暂时处理 -->
                        <img class="avatar" v-lazy="item.avatar + '?imageView2/1/w/84/h/84'"/>
                        <!-- <span v-if="item.level" class="icon" :style="{'background-color' : levelInfos[item.level-1].bgc}" style="top: 30px; height: 18px; width: 18px;"><i  class="iconfont" :class="[levelInfos[item.level-1].icon]"></i></span> -->
                        <span class="name">
                          {{ item.name || 'gems' }}
                          <!-- <span class="level-name" v-if="item.level" @click="privateChat(item.qrCode)">{{ levelInfos[item.level-1].name }}</span> -->
                        </span>
                        
                        <template v-if="!focus && item.userId !== $store.state.userInfo.userId">
                            <van-button v-if="isFocused(item.userId)" class="button-focus active" size="small" @click="onFocus(item.userId, -1)">
                                已关注
                            </van-button>
                            <van-button v-else class="button-focus" size="small" @click="onFocus(item.userId)">关注
                            </van-button>
                        </template>
                    </div>

                    <div class="body">
                        <p style="font-size: 14px">{{ item.content }}</p>
                        <div class="album" v-if="item.type===0 || item.type === 1">
                            <img v-for="(image, k) in item.album" :key="k" v-lazy="thumbnail(image, item.album.length)" :class="{single: item.album.length === 1}"
                                 @click="preview(item.album, k,key)" />
                            <span v-if="item.video" class="play"  @click="preview(item.album, k,key)"><i class="iconfont icon-bofang1"></i></span>
                        </div>
                        <div class="headline" v-if="item.type === 2" @click="GotoArticle(item.link.url)">
                          <img :src="item.link.thumbnail | thumbnail(120,120)" alt=""> 
                          <span class="description">{{ item.link.description }}</span>
                        </div>  
                    </div>

                    <div class="comment">
                        <div class="action">
                            <div>
                                <span>{{item.createTime | formatTime }}</span>
                                <span class="delete" v-if="item.userId === $store.state.userInfo.userId || $store.state.userInfo.isFrontAdmin" @click.stop="onTalkDelete(item, key)">删除</span>
                            </div>
                            <i class="iconfont icon-pinglun1" @click.stop="commentSwitch(item)"></i>
                            <div class="tag-tip" v-if="item.commentSwitch">
                                <span v-if="item.level && item.qrCode" @click="privateChat(item.qrCode)">
                                  <i class="iconfont icon-siliao"></i> 私聊
                                </span>
                                <span v-if="item.level && item.qrCode">|</span>
                                <span v-if="item.likeUserIds.indexOf($store.state.userInfo.userId) > -1" @click="unlike(item)">
                                  <i class="iconfont icon-zanshoushi"></i> 取消</span>
                                <span v-else @click="like(item)">
                                  <i class="iconfont icon-zanshoushi"></i> 赞
                                </span>
                                <span>|</span> 
                                <span @click.stop="onComment(item)">
                                  <i class="iconfont icon-xiaoxi"></i> 评论
                                </span>
                            </div>
                        </div>
                        <div class="like" v-if="item.likeUsers.length">
                            <i class="iconfont icon-zanshoushi"></i>
                            <span v-for="(user, key) in item.likeUsers" :key="key" >{{ user.name || 'NPC' }}
                                <template v-if="key !== item.likeUsers.length - 1">,</template>
                            </span>
                        </div>
                        <div class="comment-list" v-if="item.comments.length > 0">
                            <talk-comments-line :comments="item.comments" :objectId="item.id" @reply="onReply" :isSelf="item.userId === $store.state.userInfo.userId"></talk-comments-line>
                        </div>
                    </div>
                </div>

                <list-foot v-if="isError" @click.native="onLoad">出错了</list-foot>
                <!--<list-foot v-else-if="hasLoaded && list.length === 0">没有数据</list-foot>-->
                <!-- <list-foot v-if="finished">到底了</list-foot> -->
            </van-list>

        </van-pull-refresh>

        <Comment v-show="commentShow" id="comment" :object-id="formComment.id" :parent-id="formComment.parentId"
                 type="talk" @success="onCommented" v-model="formComment.content" :placeholder="formComment.placeholder" :focus="commentShow"></Comment>
        <!--<we-chat-share-->
        <!--id="TalkList"-->
        <!--title="'涂涂圈层'"-->
        <!--description="'涂涂圈层'"-->
        <!--thumbnail="http://img.tutubox.cn/no-pic-default-2.png?imageView2/1/w/80/h/80">-->
        <!--</we-chat-share>-->
        <van-popup v-model="showQrCode">
          <div class="qrCode">
            <img :src="qrCodeUrl" @click="saveImage">
            <span v-if="$isWeChat" class="WeChat-qrCode">长按识别微信二维码</span>
            <span v-if="isApp==='true'" class="app-qrCode">点击二维码保存在本地,打开微信扫一扫添加好友,进行沟通</span>
          </div>
        </van-popup>

        <!-- <van-popup v-model="appImgSave" position="bottom" >
            <div class="popup-content">
                <div @click="appSaveQrcode" class="popup-save">保存二维码</div>
                <div @click="appImgSave = false" class="popup-cancel">取消</div>
            </div>
        </van-popup> -->

        <van-popup v-model="showVideo" style="width: 100%; height:70%; background-color:rgba(0,0,0,1)" :overlay-style="{'background-color': 'rgba(0,0,0,1)'}" @close="closeVideo">
          <video :src="videoSrc" controls autoplay loop playsinline id="video"></video>
        </van-popup>
    </div>
</template>

<script>
  import ListFoot from '@/components/ListFoot';
  import Comment from '@/components/Comment';
  import TalkCommentsLine from '@/components/TalkCommentsLine';
  import {List, Cell, PullRefresh, Button, Toast, Lazyload, ImagePreview, Dialog, Popup } from 'vant';
  import ImgSrc from '@/assets/ImgSrc';
  import { mapState, mapMutations } from 'vuex';
  import que from 'axios'
  // import { loadAppQuery } from '@/utils/AppAuth'
  // import { saveImageToLocal } from '@/utils/AppInterface'

  // import {Voucher} from '@/api/wechat';

  const LazyloadOptions = {
    loading: `${ImgSrc.IMG_DEFAULT}?imageView2/1/w/160/h/164`,
    error: `${ImgSrc.IMG_ERROR}?imageView2/1/w/160/h/164`,
    preload: `${ImgSrc.IMG_DEFAULT}?imageView2/1/w/160/h/164`
  };
  import Vue from 'vue'
  Vue.use(List).use(Cell).use(PullRefresh).use(Button).use(Toast).use(Lazyload, LazyloadOptions).use(Dialog).use(Popup);

  export default {

    name: 'TalkList',

    components: { Comment, ListFoot, TalkCommentsLine },

    props: {
      page: {
        type: Number,
        default: 1
      },
      pageSize: {
        type: Number,
        default: 20
      },
      userId: {
        type: Number,
        default: 0
      },
      focus: {
        type: Boolean,
        default: false
      },
      fromPath: {
        type: String,
        default: ''
      }
    },

    data() {
      return {
        active: 0,
        list: [],
        loading: false,
        finished: false,
        hasLoaded: false,
        isError: false,
        countPullRefresh: 0,
        loadingPullRefresh: false,
        form: {
          page: this.page,
          pageSize: this.pageSize,
          userId: this.userId,
          focus: this.focus
        },
        commentShow: false,
        formComment: {
          type: 'talk',
          id: '',
          parentId: '',
          show: false,
          item: null,
          content: '',
          placeholder: ''
        },
        levelInfos: [
          {'icon': 'icon-kefu-', name:'客服', bgc:'#5393cf'},
          {'icon': 'icon-laoban', name:'老板', bgc:'#4fb99f'},
          {'icon': 'icon-dav', name:'大V', bgc:'#f5ac3a'},
          {'icon': 'icon-shejishi-', name:'设计师', bgc:'#d81e2a'},
        ],
        showQrCode: false,
        qrCodeUrl: '',
        appImgSave: false,
        isApp: false,
        wx: null,
        showVideo: false,
        videoSrc: '',
        // overlayStyle: {'background-color': 'rgba(0,0,0,1)'}
      }
    },

    computed: {
      ...mapState([
        'LevelInfo'
      ])  
    },

    watch: {
      LevelInfo: {
        handler(curVal) {
            this.list.forEach((ele)=>{
              if(ele.userId === curVal.userId) {
                ele.level = curVal.level
              }
            })
        },
        deep: true
      }
    },

    methods: {

      onReply({comment, objectId}) {
        // console.log('reply', comment);
        this.formComment.placeholder = `@${comment.name || 'NPC'}`;
        this.formComment.item = comment.children;
        this.formComment.id = objectId;
        this.formComment.parentId = comment.id;
        this.commentShow = true;
      },

      GotoArticle(site) {
        this.$router.push(site.split('#')[1])
      },

      onCommentClick(comment, item) {
        if (comment.userId !== this.$store.state.userInfo.userId && item.userId !== this.$store.state.userInfo.userId) {
          return;
        }
        if (typeof comment.deleteSwitch === 'undefined') {
          Vue.set(comment, 'deleteSwitch', true);
        } else {
          comment.deleteSwitch = !comment.deleteSwitch;
        }
        if (comment.deleteSwitch) {
          setTimeout(() => {
            comment.deleteSwitch = false;
          }, 3500);
        }
      },

      onDeleteComment(comments, item, key) {
        if (comment.userId !== this.$store.state.userInfo.userId && item.userId !== this.$store.state.userInfo.userId) {
          return;
        }
        Dialog.confirm({
          message: '确定删除?'
        }).then(() => {
          this.$http.post('/api/comment/delete', {id: item.id}).then(() => {
            Toast('删除成功');
            comments.splice(key, 1);
          });
        }).catch(() => {
        });
      },

      onTalkDelete(item, key) {
        Dialog.confirm({
          message: '确定删除?'
        }).then(() => {
          this.$http.post('/api/talk/delete', {id: item.id}).then(() => {
            Toast('删除成功');
            this.list.splice(key, 1);
          });
        }).catch(() => {
        });
      },

      onComment(item) {
        this.formComment.id = item.id;
        this.formComment.parentId = 0;
        this.commentShow = true;
        this.formComment.item = item.comments;
        item.commentSwitch = false;
      },

      onCommented({content}) {
        this.commentShow = false;
        this.formComment.placeholder = '';
        this.formComment.content = '';
        Toast('评论成功');
        this.formComment.item.push({
          userId: this.$store.state.userInfo.userId,
          name: this.$store.state.userInfo.name,
          avatar: this.$store.state.userInfo.avatar,
          content,
          like: 0,
          likeUserIds: [],
          parentId: '0'
        });
      },

      onLoad(done) {
        this.loading = true;
        this.isError = false;
        this.$http.post('/api/talk/page', this.form).then(data => {
          this.form.page++;
          data.forEach(item => {
            let exist = false;
            //去重复
            this.list.some(i => {
              if (i.id === item.id) {
                exist = true;
                return true;
              }
            });
            if (!exist) {
              item.commentSwitch = false;
              //fixme:OSS未支持https,兼容处理
              item.avatar = item.avatar.replace(/(https?:)?\/\//, 'http://')
              item.album.forEach((image, i) => {
                item.album[i] = image.replace(/(https?:)?\/\//, 'http://')
              });
              this.list.push(item);
            }
          });

          //没了
          if (data.length < this.pageSize) {
            this.finished = true;
          }

          this.loading = false;
          this.hasLoaded = true;

          if (done) done();

        }).catch((res) => {
          console.log(res);
          this.loading = false;
          this.isError = true;
          this.hasLoaded = true;
        });
      },

      onRefresh() {
        this.form.page = 1;
        this.list = [];
        this.onLoad(() => {
          // this.$toast('刷新成功');
          this.loadingPullRefresh = false;
          this.countPullRefresh++;
        });
      },

      onFocus(userId, type = 1) {
        if (1 === type) {
          this.$http.post('/api/user_more/follow', {id: userId}).then(() => {
            Toast('关注成功');
            let followUserIds = [...this.$store.state.userInfo.followUserIds];
            followUserIds.push(userId);
            this.$store.commit('USER_INFO', {
              follow: this.$store.state.userInfo.follow + 1,
              followUserIds
            });
          });
        } else {
          this.$http.post('/api/user_more/unFollow', {id: userId}).then(() => {
            Toast('已取消关注');
            let followUserIds = [...this.$store.state.userInfo.followUserIds];
            let index = followUserIds.indexOf(userId);
            followUserIds.splice(index, 1);
            this.$store.commit('USER_INFO', {
              follow: this.$store.state.userInfo.follow - 1,
              followUserIds
            });
          });
        }
      },

      isFocused(userId) {
        return this.$store.state.userInfo.followUserIds.indexOf(userId) > -1;
      },

      preview(album, index = 0, key) {
        // if(this.$isWeChat) {
        //   if(this.list[key].video) {
        //     this.showVideo = true;
        //     this.videoSrc = this.list[key].video
        //   }else {
        //     this.wx.previewImage({
        //       current: album[index], // 当前显示的图片链接
        //       urls: album// 需要预览的图片链接列表
        //     });
        //   }
          
        if(this.list[key].video) {
          this.showVideo = true;
          this.videoSrc = this.list[key].video

        }else {
          // 清楚预览缓存         
          ImagePreview({
            images: album,
            startPosition: index,
            showIndex: false,
            showIndicators: true,
          });
          
        }
      },

      closeVideo() {
        this.videoSrc = ''
        document.getElementById('video').style.zIndex = -1
      },
      
      thumbnail(url, length) {
        return length === 1 ? `${url}?imageView2/1/w/372/h/352` : `${url}?imageView2/1/w/160/h/164`;
      },

      commentSwitch(item) {
        // console.log(item);
        if (item) {
          item.commentSwitch = true;
          setTimeout(() => {
            item.commentSwitch = false;
          }, 4000);
        } else {
          // item.commentSwitch = false;
          this.list.forEach(item => {
            item.commentSwitch = false;
          });
          this.commentShow = false;
        }
      },

      privateChat(url) {
        if(url) {
          this.showQrCode = true
          this.qrCodeUrl = url
        } 
      },

      like(item) {
        this.$http.post('/api/talk/like', {id: item.id}).then(() => {
          let user = {
            id: this.$store.state.userInfo.userId,
            name: this.$store.state.userInfo.name,
            avatar: this.$store.state.userInfo.avatar
          };
          item.likeUserIds.push(user.id);
          item.likeUsers.push(user);
        });
      },

      unlike(item) {
        this.$http.post('/api/talk/unlike', {id: item.id}).then(() => {
          let userId = this.$store.state.userInfo.userId,
            index = item.likeUserIds.indexOf(userId);
          item.likeUserIds.splice(index, 1);
          item.likeUsers.splice(index, 1);
        });
      },

      saveImage() {
        if(this.isApp == 'true') {
          this.appImgSave = true
        }
      },

      // appSaveQrcode() {
      //   // console.log('listSS');
      //   saveImageToLocal(this.qrCodeUrl)
      // },

          /**
      * 保存图片至本地完成
      */
      // onSaveImageFinished(jsonStr) {
      // 	console.log('onSaveImageFinished: ', jsonStr);
      // 	var jsonObj = JSON.parse(jsonStr);
      // 	var success = jsonObj.success;//保存是否成功
      // 	var localPath = jsonObj.localPath;//本地保存路径
      //   var error = jsonObj.error;//保存失败信息
      //   if(success) {
      //     Toast('已保存在系统相册~')
      //     this.appImgSave = false
      //   }else if(error) {
      //     Toast('保存失败~')
      //   }
      // },

      ...mapMutations({
        setPhotoPreview: 'SET_PHOTO_PREVIEW'
      })
    },

    created() {
      // this.isApp = loadAppQuery()
      // // console.log(this.isApp);
      // window['onSaveImageFinished'] = (jsonStr) => {
      //   this.onSaveImageFinished(jsonStr)
      // }
    },

    activated() {
      // console.log(this.fromPath);
      // if(this.$isWeChat) {
      //   Voucher(`${window.location.href.split('#')[0]}`, 'previewImage').then(_wx => {
      //           this.wx = _wx;
      //   })
      // }
     
      if (["/publish", "/publish-we-chat"].includes(this.fromPath) || this.isError) {
        this.onRefresh();
      }
    }
  }
</script>

<style scoped lang="less">
 

    #talk-list {
      background-color: #fff;
        .talk {
            margin: 20px;
            padding-bottom: 20px;
            border-bottom: 1px solid #eee;
            .head {
                display: -webkit-flex; /* Safari */
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                position: relative;
                .avatar {
                    width: 42px;
                    height: 42px;
                    border-radius: 50%;
                }
                .icon{
                    position: absolute;
                    top: 30px;
                    left: 28px;
                    width: 18px;
                    height: 18px;
                    // text-align: center;
                    border-radius: 50%;  
                    color: #ffffff;
                    .iconfont{
                      position: absolute;
                      top: 50%;
                      left: 50%;
                      transform: translate(-50%,-50%);
                    }                
                }
                .name {
                    flex: 1;
                    text-align: left;
                    padding: 0 8px;
                    font-size: 14px;
                    color: #888;
                    .level-name{
                      font-size: 10px;
                      color: #bea473;
                    }
                }
                
                .button-focus {
                    width: 54px;
                    height: 22px;
                    line-height: 22px;
                    background-color: white;
                    color: #e9aea8;
                    border-color: #e9aea8;
                }
                .button-focus.active {
                    color: white;
                    background-color: #e9aea8;
                }
            }
            .body {
                margin-top: -15px;
                padding-left: 50px;
                text-align: left;
                p {
                    word-break: break-word;
                    margin-bottom: 10px;
                }
                .album {
                    display: flex;
                    justify-content: left;
                    flex-flow: row wrap;
                    position: relative;
                    img {
                        margin-right: 4px;
                        margin-bottom: 4px;
                        width: 80px;
                        height: 82px;
                    }
                    img.single {
                        width: 186px;
                        height: 176px;
                    }
                    .play{
                      position: absolute;
                      top: 60px;
                      left: 70px;
                      .iconfont{
                        font-size: 50px;
                        color: #ffffff;
                      }
                    }
                }
                .headline{
                  background-color: #EEEEEE;
                  position: relative;
                  height: 60px;
                  img{
                    width: 60px;
                    height: 60px;
                  }
                  .description{
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    font-weight:500;
                    color:rgba(34,34,34,1);
                    font-size: 12px;
                    margin-left: 12px;
                    margin-right: 8px;
                    text-overflow:ellipsis;
                    // white-space:;
                    white-space: nowrap;
                    overflow:hidden;
                    width: 180px;
                    // height: 40px;
                  }
                }
            }
            .comment {
                padding-left: 50px;
                .action {
                    display: flex;
                    position: relative;
                    justify-content: space-between;
                    margin: 5px 0;
                    .tag-tip {
                        position: absolute;
                        top: -10px;
                        right: 35px;
                        // width: 150px;
                        height: 30px;
                        // line-height: 30px;
                        color: white;
                        border-radius: 5px;
                        background-color: #262d34;
                        display: -webkit-box;
                        display: -ms-flexbox;
                        display: flex;
                        -webkit-box-pack: justify;
                        -ms-flex-pack: justify;
                        justify-content: space-between;
                        align-items: center;
                        padding: 5px 10px;
                        span{
                          margin: 0 5px;
                        };
                    }
                    > div {
                        font-size: 12px;
                    }
                    .delete {
                        margin-left: 10px;
                        color: cornflowerblue;
                    }
                }
                .like {
                    text-align: left;
                    background-color: #f3f3f3;
                    padding: 4px;
                    font-size: 13px;
                    span {
                        margin-left: 3px;
                        color: cornflowerblue;
                    }
                }
                .comment-list {
                    /*padding: 6px;*/
                    /*text-align: left;*/
                    /*border-top: 1px solid #eee;*/
                    /*background-color: #f3f3f3;*/
                    /*color: #707070;*/
                    /*/deep/ img {*/
                    /*zoom: .8;*/
                    /*margin-bottom: -5px;*/
                    /*}*/
                    /*> div {*/
                    /*position: relative;*/
                    /*font-size: 13px;*/
                    /*.name {*/
                    /*color: cornflowerblue;*/
                    /*}*/
                    /*.delete {*/
                    /*position: absolute;*/
                    /*top: 2px;*/
                    /*right: 2px;*/
                    /*font-size: 12px;*/
                    /*color: cornflowerblue;*/
                    /*}*/
                    /*}*/
                }
            }
        }
        #comment {
            position: fixed;
            width: 100%;
            bottom: 50px;
            left: 0;
            
        }
        /deep/ .van-popup{
          // height: 320px;
          // border-radius: 10px;
          // padding: 10px 5px;
          text-align: center;  
          img{
            width: 250px;
            height: 250px;
            margin-bottom: 23px;
          }
          .WeChat-qrCode{
            font-size:14px;
            font-weight:400;
            color:rgba(36,13,41,1);
          }
          .app-qrCode{
            font-size:14px;
            font-weight:400;
            color:rgba(36,13,41,1);
          }
        }  
        .popup-content{
          div{
              text-align: center;
              height: 50px;
              line-height: 50px;
              background-color: #fff;
              font-size: 18px;
          }
          .popup-save{
              border-bottom: 1px solid #dad5db;
          }   
        }

        #video{
          width: 100%;
        }
    }
   
</style>

